/**
 * CSGPolygon3D registration: the parser.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseCSGPolygon3D } from './parser';
const cSGPolygon3DRegistration = {
    typeName: 'CSGPolygon3D',
    parser: parseCSGPolygon3D,
};
nodeRegistry.register(cSGPolygon3DRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map